<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousAir" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Sea Import Payment</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button
                v-if="mainEntryData.length>0 && mainEntryData[0].shippingArrivalNoticmailSentDate == null"
                @click="SendShipmentArrival"
                size="sm"
                variant="warning"
                >Send Shipment Arrival Notice</b-button
              >
            </b-nav-form>
            <b-nav-form>
              <b-button
                size="sm"
                class="ml-2"
                variant="success"
                v-if="mainPageModal.ffImportPayId != ''"
                id="addButtonLoaderpro"
                @click="proceedInvoice"
                >Generate Invoice</b-button
              >
            </b-nav-form>
            <b-nav-form>
              <!-- v-if="$sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh'" -->
              <b-button
                class="ml-2"
                size="sm"
                variant="primary"
                @click="emailChecklist('PAYTEST')"
                id="addButtonLoaderVGM"
                >S-Line Payment Request</b-button
              >
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <banner-component
          :allModuleIdBanner="this.ALLMODULE ? this.ALLMODULE : ''"
          :jobSeriesBanner="this.JOBSERIES ? this.JOBSERIES : ''"
          :bannerClientName="this.CLIENTNAME ? this.CLIENTNAME : ''"
          iconId="fa fa-ship"
          :prbr_id="this.prbr_id?this.prbr_id:''"
        />
        <b-card class="formCard">
          <b-card-text>
            <!-- <b-card style="height:90px !important" class="HeaderMastBanner">
              <md-layout gutter>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <b>Assignment No. : {{mainEntryData[0].ffImportSeries}}</b>
                  </md-layout>
                </md-layout>
              
                <md-layout md-flex="40">
                  <md-layout md-flex="100">
                    <b>Shipping Line : {{mainEntryData[0].shippingLine}}</b>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout gutter>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <b>Importer Name : {{mainEntryData[0].Importer}}</b>
                  </md-layout>
                </md-layout>
               
                <md-layout md-flex="40">
                  <md-layout md-flex="100"></md-layout>
                </md-layout>
              </md-layout>
              <md-layout gutter>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <b>
                      Exporter Name : {{mainEntryData[0].Exporter}}
                      <br>
                    </b>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="25"></md-layout>
                <md-layout md-flex="40">
                  <md-layout md-flex="100"></md-layout>
                </md-layout>
              </md-layout>
            </b-card>
            <hr> -->
            <b-card
              class="gutr"
              v-for="(item, index) in mainPageModal.doSection"
              :key="index"
              style="background: whiteSmoke"
            >
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="25">
                  <label for="stuffingType">
                    <b>Do / Security</b>
                  </label>
                  <model-list-select
                    :list="doSecurityList"
                    v-model="item.doOrSecurity"
                    option-value="doSecV"
                    option-text="doSecT"
                    placeholder="Select "
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr" style="margin-bottom: 15px">
                <b-button
                  size="sm"
                  style="margin-top: 42px"
                  @click="showDocModal"
                  variant="dark"
                  >Upload Document</b-button
                >

                <!-- <md-layout md-flex="25">
                  <md-input-container>
                    <label>Upload Document</label>
                    <md-file
                      name="uploadboe"
                      id="boe"
                      v-model="item.uploadDoC"
                      @selected="onFileChange('DOC',index)"
                    ></md-file>
                  </md-input-container>
                </md-layout> -->
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="20">
                  <label for="stuffingType">Document Details</label>
                  <b-textarea
                    style="height: 37px"
                    name="securityAmount"
                    id="securityAmount"
                    v-model="item.doParticulars"
                  ></b-textarea>
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label for="stuffingType">Paid By</label>

                  <model-list-select
                    :list="paidByList"
                    v-model="item.doPaidBy"
                    option-value="paidV"
                    option-text="paidT"
                    placeholder="Select Paid By"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="15">
                  <label>Payment Date</label>

                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    id="receivedDo"
                    name="receivedDo"
                    v-model="item.doPaymentDate"
                  ></date-picker>
                </md-layout>

                <b-button
                  class="ml-2"
                  v-if="index == '0'"
                  size="sm"
                  variant="outline-dark"
                  style="margin-top: 34px"
                  @click="addAdditionalDo"
                >
                  Add More
                </b-button>
                <b-button
                  v-else
                  size="sm"
                  variant="outline-dark"
                  style="margin-top: 34px"
                  @click="removeDoSection(index)"
                  class="ml-2"
                >
                  Remove
                </b-button>
              </md-layout>
              <md-layout md-gutter v-if="item.uploadDoC != ''">
                <md-layout md-flex="25">
                  <a
                    :href="`${docURL}/FF_Sea_Import_Uploads/` + item.uploadDoC"
                    target="_blank"
                    download
                    >View Document - {{ index + 1 }}</a
                  >
                </md-layout>
              </md-layout>
            </b-card>

            <md-layout md-gutter class="gutr">
              <b-button
                size="sm"
                style="margin-top: 42px"
                @click="showDocModal"
                variant="dark"
                >Upload DO</b-button
              >
              <!-- <md-layout md-flex="25">
                <md-input-container>
                  <label>Upload Do</label>
                  <md-file
                    name="uploadboe"
                    id="boe"
                    @selected="onFileChange('DO')"
                    v-model="mainPageModal.uploadDO"
                  ></md-file>
                </md-input-container>
              </md-layout> -->

              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="15">
                <label>Do Release Date</label>

                <date-picker
                  :format="selectDateFormat"
                  lang="en"
                  id="receivedDo"
                  name="receivedDo"
                  v-model="mainPageModal.doReleaseDate"
                ></date-picker>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="50">
                <md-layout md-flex="100">
                  <label>Remarks</label>
                  <b-form-textarea
                    :formatter="capitalizeAll"
                    id="doRemarks"
                    name="doRemarks"
                    v-model="mainPageModal.doRemarks"
                  ></b-form-textarea>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter v-if="secBlUploadView.length > 0">
              <md-layout
                md-flex="25"
                v-for="(item, index) in secBlUploadView"
                :key="index"
              >
                <a
                  :href="`${docURL}/FF_Sea_Import_Uploads/` + item"
                  target="_blank"
                  download
                  >View Document - {{ index + 1 }}</a
                >
              </md-layout>
            </md-layout>

            <div class="gutr">
              <div>
                <b-button
                  class="mt-3"
                  variant="primary"
                  id="addButtonLoader1"
                  @click="addPayment('0')"
                  >Save & Submit</b-button
                >
                <md-spinner
                  md-indeterminate
                  id="loader1"
                  style="display: none"
                ></md-spinner>
              </div>
              <div>
                <b-button
                  variant="primary"
                  class="mt-1"
                  id="addButtonLoader1"
                  @click="addPayment('1')"
                  >Save & Proceed To Tracking</b-button
                >
                <md-spinner
                  md-indeterminate
                  id="loader1"
                  style="display: none"
                ></md-spinner>
              </div>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <div v-if="ALLMODULE">
      <b-modal
        size="xl"
        class="modal-dialog-doc"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title=""
      >
        <div>
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button
          class="mt-3"
          variant="outline-danger"
          block
          @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
    </div>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <md-dialog-alert
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop2"
      @close="onClose"
    ></md-dialog-confirm>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="alertAddSeaImp"
      @close="onCloseHandover"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="message"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import axios from "axios";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../helper/collection";
import BannerComponent from "../allModuleForm/bannerComponent.vue";

import VueTrix from "vue-trix";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import DocForm from "../../component/allModuleForm/docLibrary.vue";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Sea Freight") &&
      this.$sessionsStorage.get("editffSeaImportId") != "" &&
      this.$sessionsStorage.get("editffSeaImportId") != undefined
    ) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/seaImport/ffSeaImportExecution"
      );

      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  beforeDestroy() {},
  data() {
    return {
      syncType: "",
      syncSeries: "",
      syncFlag: false,
      invnoErrFlag: false,
      pageRoute: "",
      selectDateFormat,
      prbr_id:"",
      ALLMODULE: "",
      JOBSERIES: "",
      CLIENTNAME: "",
      // Added By Priyanshu Singh Start
      PORTINFO: "",
      portType: "",
      stuffingType: "",
      containerInfo: "",
      transportationBy: "",
      ccExecDetail: [],
      pageRoute: "",
      EdiExecutionModel: {
        PORTINFO: "",
        portType: "",
        stuffingType: "",
        containerInfo: "",
        transportationBy: "",
        allModuleId: "",
        checklistUpload: "",
        vgmUpload: "",
        vgmBy: "",
        ffExecutionId: "",
        ffImportId: this.$sessionsStorage.get("editffSeaImportId"),
        ccType: "",
        assignmentNumber: "",
        DIN: "",
        IRN: "",
        billEntryNumber: "",
        uploadBoe: [],
        billEntryDate: "",
        challanNo: "",
        mainRemarks: "",
      },
      // Added By Priyanshu Singh End
      docURL: URL_BASE_DOC,
      editorOption: {
        modules: {},
      },
      editorContent: "",
      isLoading: false,
      mainEntryData: [],
      doSecurityList: [
        {
          doSecV: "1",
          doSecT: "Shipping Line Invoice",
        },
        {
          doSecV: "2",
          doSecT: "Security Details",
        },
      ],

      value12: "",
      getCLientData: ["gfdg"],

      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      lastTrapArray: "",
      lastTransID: false,
      mainPageModal: {
        uploadDO: "",
        doReleaseDate: "",
        doRemarks: "",
        ffImportPayId: "",
        ffImportId: this.$sessionsStorage.get("editffSeaImportId"),

        ffImportSeries: "",
        doSection: [
          {
            doOrSecurity: "",
            uploadDoC: "",
            doParticulars: "",
            doPaymentDate: "",
            doPaidBy: "",
          },
        ],
      },

      paidByList: [
        {
          paidV: "1",
          paidT: "Pridel",
        },
        {
          paidV: "2",
          paidT: "Importer ",
        },
      ],

      deleteId: "",
      validate: true,
      validateTrans: true,

      editIndex: "",
    };
  },

  mounted() {},
  watch: {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    VueTrix,
    quillEditor,
    DocForm,
    BannerComponent,
  },
  computed: {
    clientList() {
      return this.getCLientData;
    },

    uploadBookingStatus() {
      return this.BookingShippingLine.uploadBooking != ""
        ? this.BookingShippingLine.uploadBooking.split(",")
        : [];
    },
    tentativeDetailArrayList() {
      return this.tentativeDetailArray;
    },
    portList() {
      return this.portMasterList;
    },

    bookingShipmentList() {
      return this.bookingShipmentName;
    },
    secBlUploadView() {
      return this.mainPageModal.uploadDO != ""
        ? this.mainPageModal.uploadDO.split(",")
        : [];
    },
  },
  methods: {
    validateCheckList(id) {
      let validate_new = true;

      Object.keys(this.errorExecutionModel).map((x) => {
        if (this.ExecutionModel[x] == "") {
          validate_new = false;
          this.errorExecutionModel[x] = this.arrayErrorExecutionModel[x];
        } else {
          this.errorExecutionModel[x] = "";
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    validateExecution() {
      let validate_new = true;
      Object.keys(this.errorExecution).map((x, index) => {
        if (this.factoryStuffing[x] == "") {
          this.errorExecution[x] = this.arrayExecutionError[index];
          validate_new = false;
        }

        // if (this.containerTypeDetailFactory.length == 0) {
        //   this.errorAtleastContainer = "Select Atleast one Container";

        //   validate_new = false;
        // } else {
        //   this.errorAtleastContainer = "";
        // }

        // if (this.sbDetailArrayList.length == 0) {
        //   this.showMoreSB = true;
        //   this.errorAtleastSb = "Add Atleast one S/B Detail";
        //   validate_new = false;
        // } else {
        //   this.errorAtleastSb = "";
        //   this.showMoreSB = false;
        // }
      });

      if (validate_new == false) {
        window.scroll(0, 50);

        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },
    // addFactoryExecution(id) {
    //   // this.factoryStuffing["vgmArryList"] = this.vgmArryList;
    //   // this.factoryStuffing.portType = this.PORTINFO;

    //   this.nextPageType = id;
    //   if (
    //     this.nextPageType == "handover" &&
    //     this.factoryStuffing.vgmSubmissionDate == ""
    //   ) {
    //     this.alert.content =
    //       "VGM Submission Date  must be entered before proceeding to Handover";
    //     this.$refs["addPop"].open();
    //     return false;
    //   }

    //   // if (
    //   //   this.nextPageType == "handover" &&
    //   //   this.factoryStuffing.examinationComplete == "No"
    //   // ) {
    //   //   this.alert.content = "Examination is not Completed";
    //   //   this.$refs["addPop"].open();
    //   //   return false;
    //   // }
    //   // this.validateExecution();

    //   if (this.validateTrans != false) {
    //     if (id == "handover") {
    //       $("#addButtonLoaderHand").css("display", "none");
    //       $("#loaderHand").css("display", "block");
    //     }
    //     if (id == "BLRaised") {
    //       $("#addButtonLoaderBL").css("display", "none");
    //       $("#loaderBL").css("display", "block");
    //     }
    //     if (id == "VGM") {
    //       $("#addButtonLoaderRail").css("display", "none");
    //       $("#loaderRail").css("display", "block");
    //     }
    //     console.log(this.factoryStuffing);

    //     let options = {
    //       method: "POST",
    //       url: `${URL_BASE}/Api_FFSeaExport/addExecutionFacftory.php`,
    //       data: JSON.stringify(this.factoryStuffing),
    //       crossDomain: true,

    //       headers: {
    //         Accept: "application/json",
    //         "Content-Type": "application/json",
    //         Authorization: this.$sessionsStorage.get("loginId"),
    //       },
    //     };

    //     axios(options)
    //       .then((result) => {
    //         const { statusText, status, data } = result;
    //         if ( status == 200 && data) {
    //           if (this.mainEntryData[0].newContainerFlow == "1") {
    //             this.$sessionsStorage.set(
    //               "editFFExecutionId",
    //               data.ffExecutionId
    //             );
    //             this.factoryStuffing.ffExecutionId = data.ffExecutionId;
    //           }
    //           // this.$sessionsStorage.set(
    //           // this.$sessionsStorage.set(
    //           //   "editFFExecutionId",
    //           //   data.ffExecutionId
    //           // );
    //           // this.factoryStuffing.ffExecutionId = data.ffExecutionId;

    //           if (id == "VGM") {
    //             $("#loaderRail").css("display", "none");
    //             $("#addButtonLoaderRail").css("display", "block");
    //           }
    //           if (id == "handover") {
    //             $("#loaderHand").css("display", "none");
    //             $("#addButtonLoaderHand").css("display", "block");
    //           }

    //           if (id == "BLRaised") {
    //             $("#loaderBL").css("display", "none");
    //             $("#addButtonLoaderBL").css("display", "block");
    //           }

    //           if (data.msg == "Inserted Successfully") {
    //             this.alert.content = "Data Added Successfully";
    //           } else {
    //             this.alert.content = "Data Updated Successfully";
    //           }
    //           this.$refs["addPop2"].open();
    //           if (this.nextPageType == "SAVE") {
    //             this.getData();
    //           }
    //         }
    //       })
    //       .catch((error) => {});
    //   }
    // },
    onCloseHandover(type) {
      // if (type != "cancel") {
      // alert(this.pageRoute);
      if (this.pageRoute == "PAYTEST") {
        this.$router.push({
          path: "/seaImport/ffSLinePaymentImportN",
        });
      }
      // }
    },
    checkSlinePayment() {
      return new Promise((resolve) => {
        let payLoad = {
          module_type: "FF Import",
          allModuleId: this.ALLMODULE,
          assignment_no: this.JOBSERIES,
          type: this.TYPE,
        };
        // console.log("MypayLoad=>",payLoad.length);return false;
        if (payLoad != "") {
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_SlineBillingCCExport/checkSlinePaymentcreated.php`,
            data: JSON.stringify(payLoad),
            crossDomain: true,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              if (status == 200 && data) {
                console.log(data);
                console.log(data.find);
                if (data.find == 1) {
                  this.invnoErrFlag = true;
                  this.syncType = data.moduleType;
                  this.syncSeries = data.mainSalesSeries;
                } else if (data.find == 0) {
                  this.invnoErrFlag = false;
                }
                this.syncFlag = true;
                return resolve(!this.invnoErrFlag);
              }
            })
            .catch((error) => {});
        }
      });
    },
    async emailChecklist(id) {
      if (id == "PAYTEST") {
        let checkValueExit = await this.checkSlinePayment();
        console.log("checkValueExit", checkValueExit);

        if (!checkValueExit) {
          if (this.syncType != "FF Import") {
            this.alert.content =
              "The Payment Request has Already been Raised in '" +
              this.syncType +
              "' Assignment No. '" +
              this.syncSeries +
              "'";
            this.$refs["message"].open();
            return false;
          }
        }
      }
      // this.EdiExecutionModel["multiShippingBill"] = this.multiShippingBill;
      // Added By Priyanshu Singh Start
      // alert(this.$sessionsStorage.get("editFFExecutionId"));
      this.$sessionsStorage.set("allModuleId", this.ALLMODULE);
      this.$sessionsStorage.set("TYPE", this.TYPE);
      this.$sessionsStorage.set("JOBSERIES", this.JOBSERIES);
      this.$sessionsStorage.set("EXPORTER", this.CLIENTNAME);
      // Added By Priyanshu Singh End
      // alert(this.TYPE);
      //     alert(this.EXPORTER);
      this.pageRoute = id;
      // this.validateCheckList(id);
      // console.log(this.$sessionsStorage.get());

      this.EdiExecutionModel["ffImportId"] =
        this.$sessionsStorage.get("editffSeaImportId");
      console.log(this.ccExecDetail);
      if (this.ccExecDetail.length > 0) {
        this.EdiExecutionModel.ffExecutionId =
          this.ccExecDetail[0].executionImportId;
      }

      // Added By Priyanshu Singh Start
      this.EdiExecutionModel["ffExecutionId"] =
        this.$sessionsStorage.get("editFFExecutionId");
      this.EdiExecutionModel["portType"] = this.PORTINFO;
      this.EdiExecutionModel["stuffingType"] = this.stuffingType;
      this.EdiExecutionModel["containerInfo"] = this.containerInfo;
      this.EdiExecutionModel["transportationBy"] = this.transportationBy;
      this.EdiExecutionModel["ffImportId"] =
        this.$sessionsStorage.get("editffSeaImportId");
      this.EdiExecutionModel["allModuleId"] =
        this.$sessionsStorage.get("allModuleId");
      this.EdiExecutionModel["TYPE"] = this.$sessionsStorage.get("TYPE");
      this.EdiExecutionModel["JOBSERIES"] =
        this.$sessionsStorage.get("JOBSERIES");
      this.EdiExecutionModel["EXPORTER"] =
        this.$sessionsStorage.get("EXPORTER");
      // Added By Priyanshu Singh End
      // console.log("this.EdiExecutionModel=>",this.EdiExecutionModel);return false;
      let Obj = {
        EdiExecutionModel: this.EdiExecutionModel,
        //   UploadChecklist: this.UploadChecklist,
        onlyExecMain: id == "" ? "" : "fsdf",
      };
      // console.log(Obj);return false;

      if (this.validate == true) {
        this.isLoading = true;
        if (id == "vgm") {
          $("#addButtonLoaderVgm").css("display", "none");
          $("#loaderVgm").css("display", "block");
        } else if (id == "handover") {
          $("#addButtonLoaderHand").css("display", "none");
          $("#loaderHand").css("display", "block");
        } else if (id == "BL") {
          $("#addButtonLoaderBL").css("display", "none");
          $("#loaderBL").css("display", "block");
        } else {
          $("#addButtonLoaderPay").css("display", "none");
          $("#loaderPay").css("display", "block");
        }

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_SlineBillingCCExport/addExecutionFacftory.php`,
          data: JSON.stringify(Obj),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              // console.log("data=>",data.ffExecutionId);
              //  console.log(this.mainEntryData[0].newContainerFlow)
              if (this.mainEntryData[0].newContainerFlow == "1") {
                // alert(this.$sessionsStorage.get("editFFExecutionId"));
                if (
                  !this.$sessionsStorage.get("editFFExecutionId") &&
                  this.$sessionsStorage.get("editFFExecutionId") == 0
                ) {
                  this.$sessionsStorage.set(
                    "editFFExecutionId",
                    data.ffExecutionId
                  );
                }

                // this.factoryStuffing.ffExecutionId = data.ffExecutionId;
              }
              // alert("Hellow");
              // this.$sessionsStorage.set(
              // this.$sessionsStorage.set(
              //   "editFFExecutionId",
              //   data.ffExecutionId
              // );
              // this.factoryStuffing.ffExecutionId = data.ffExecutionId;

              if (id == "VGM") {
                $("#loaderRail").css("display", "none");
                $("#addButtonLoaderRail").css("display", "block");
              }
              if (id == "handover") {
                $("#loaderHand").css("display", "none");
                $("#addButtonLoaderHand").css("display", "block");
              }

              if (id == "BLRaised") {
                $("#loaderBL").css("display", "none");
                $("#addButtonLoaderBL").css("display", "block");
              }

              if (id != "") {
                this.alert.content = "Data Updated Succesfully";
                if (id == "0") {
                  this.$refs["message"].open();
                } else {
                  this.$refs["alertAddSeaImp"].open();
                }
              }
              // alert(this.nextPageType);
              // this.$refs["addPop2"].open();
              //  if (id == "0") {
              //   this.$refs["addPop"].open();
              // } else {
              //   this.$refs["addPop2"].open();
              // }
              this.isLoading = false;
              if (this.nextPageType == "SAVE") {
                this.getData();
              }
            }
          })
          .catch((error) => {});
      }
    },
    showDocModal() {
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    SendShipmentArrival() {
      this.isLoading = true;
      let payLoad = {
        mailAlert: "mailAlert",
        sendMail: "Yes",
        ffImportId: this.$sessionsStorage.get("editffSeaImportId"),
      };
      if (this.validate == true) {
        let options = {
          method: "POST",
          url: `${URL_BASE}/sendShipmentArrivalNotice.php`,
          data: JSON.stringify(payLoad),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.isLoading = false;
              this.alert.content = "Shipment Arrival Notice Sent";

              this.$refs["addPop"].open();
            }
          })
          .catch((error) => {});
      }
    },
    onFileChange(ID, index) {
      let files = event.target.files || event.dataTransfer.files;
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        if (ID == "DOC") {
          formData.append(
            "moduleId",
            this.$sessionsStorage.get("editffSeaImportId") + "-" + index
          );
        } else {
          "moduleId", this.$sessionsStorage.get("editffSeaImportId");
        }

        if (ID == "DOC") {
          formData.append("staticFileName", "Sea_Import_ExecDoc");
        } else if (ID == "DO") {
          formData.append("staticFileName", "Sea_Import_DO");
        } else {
          console.log("errorGone");
        }

        formData.append("upload_dir_folderName", "FF_Sea_Import_Uploads");
      }

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAll.php`, formData, config)
        .then((result) => {
          if (ID == "DOC") {
            this.mainPageModal.doSection[index].uploadDoC = result.data;
          } else if (ID == "DO") {
            this.mainPageModal.uploadDO = result.data;
            console.log(this.mainPageModal.uploadDO, "jhgj");
          } else {
            console.log("errorReturn");
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    proceedInvoice() {
      this.$router.push({
        path: "/seaImport/freightInvoiceForTallyImport?JobType=FF&ShipmentType=Sea&ModuleType=Import",
      });
    },
    addPayment(id) {
      this.mainPageModal["ffImportId"] =
        this.$sessionsStorage.get("editffSeaImportId");
      this.mainPageModal.doSecurityArr = JSON.stringify(
        this.mainPageModal.doSection
      );
      console.log("Priyanshu Singh=>", this.mainPageModal);
      // return false;
      if (this.validate == true) {
        $("#addButtonLoader1").css("display", "none");
        $("#loader1").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaImport/addSeaImpPayment.php`,
          data: JSON.stringify(this.mainPageModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#addButtonLoader1").css("display", "block");
              $("#loader1").css("display", "none");

              if (this.mainPageModal.ffImportPayId != "") {
                this.alert.content = "Data Updated Succesfully";
              } else {
                this.alert.content = "Data Added Succesfully";
              }
              if (id == "0") {
                this.$refs["addPop"].open();
              } else {
                this.$refs["addPop2"].open();
              }

              // this.getData();
            }
          })
          .catch((error) => {});
      }
    },
    addAdditionalDo() {
      let doSection1 = {
        doOrSecurity: "",
        uploadDoC: "",
        doParticulars: "",
        doPaidBy: "",

        doPaymentDate: "",
      };

      this.mainPageModal.doSection.push(doSection1);
    },
    removeDoSection(index) {
      this.mainPageModal.doSection.splice(index, 1);
      //  this.errorMultiContainer.splice(index, 1);
    },

    onClose() {
      this.$router.push({
        path: "/seaImport/seaImportNormalTrack",
      });
    },
    onClose6(type) {},

    previousAir() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/seaImport/ffseaImportFcl"
      // });
    },

    getData() {
      this.isLoading = true;
      let new_data = {
        ffImportId: this.$sessionsStorage.get("editffSeaImportId"),
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaImport/getDataSeaImpPayment.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            console.log("MyArr=>", data);
            this.$sessionsStorage.set("editFFExecutionId", data.SEA_FRGHT_EXEC);
            let otherNewContainerFLow = 0;
            let doReleaseDate = 0;
            let doRemarks = 0;
            let uploadDo = 0;
            let doSectionArr = [];
            if (data.containerList.length > 0) {
              this.mainEntryData = data.containerList;
              this.prbr_id = data.containerList[0].prbr_id;
              this.CLIENTNAME = data.containerList[0].Importer;
              this.ALLMODULE = data.containerList[0].allModuleId;
              this.JOBSERIES = data.containerList[0].ffImportSeries;
              this.PORTINFO = data.containerList[0].portType;
              this.portType = data.containerList[0].portType;
              this.stuffingType = data.containerList[0].stuffingType;
              this.containerInfo = data.containerList[0].containerInfo;
              otherNewContainerFLow =
                data.containerList[0].otherNewContainerFLow;
              if (
                data.containerList[0].doOrSecurity != undefined &&
                data.containerList[0].doOrSecurity != null &&
                data.containerList[0].doOrSecurity != ""
              ) {
                doSectionArr = data.containerList[0].doOrSecurity;
              }
              doReleaseDate = data.containerList[0].doReleaseDate;
              doRemarks = data.containerList[0].doRemarks;
              uploadDo = data.containerList[0].uploadDo;
              this.mainPageModal.allModuleId =
                data.containerList[0].allModuleId;

              if (data.containerList[0].tptOutSource == 1) {
                this.transportationBy = "Pridel";
              } else {
                this.transportationBy = "OutSource";
              }
            }

            this.mainPageModal.otherNewContainerFLow = otherNewContainerFLow;
            if (data.ImportPayDetails.length > 0) {
              let doParticulars = [];
              let uploadDoC = [];
              let doPaymentDate = [];
              let doPaidBy = [];
              let doOrSecurity = [];
              Object.keys(data.ImportPayDetails[0]).map((x) => {
                if (x == "doOrSecurity") {
                  if (data.ImportPayDetails[0][x] != null) {
                    doOrSecurity = data.ImportPayDetails[0][x].split(",");
                    console.log(data, "ooo");
                  } else {
                    doOrSecurity = [];
                  }
                } else if (x == "doParticulars") {
                  if (data.ImportPayDetails[0][x] != null) {
                    doParticulars = data.ImportPayDetails[0][x].split(",");
                  } else {
                    doParticulars = [];
                  }
                } else if (x == "uploadDoC") {
                  if (data.ImportPayDetails[0][x] != null) {
                    uploadDoC = data.ImportPayDetails[0][x].split(",");
                  } else {
                    uploadDoC = [];
                  }
                } else if (x == "doPaymentDate") {
                  if (data.ImportPayDetails[0][x] != null) {
                    doPaymentDate = data.ImportPayDetails[0][x].split(",");
                  } else {
                    doPaymentDate = [];
                  }
                } else if (x == "doPaidBy") {
                  if (data.ImportPayDetails[0][x] != null) {
                    doPaidBy = data.ImportPayDetails[0][x].split(",");
                  } else {
                    doPaidBy = [];
                  }
                } else {
                  this.mainPageModal[x] = data.ImportPayDetails[0][x] || "";
                }
              });
              this.mainPageModal["doSection"] = [];
              if (otherNewContainerFLow == 0) {
                if (doOrSecurity.length > 0) {
                  doOrSecurity.map((p, index) => {
                    let obj = {
                      doOrSecurity: p,
                      doParticulars: doParticulars[index],
                      doPaymentDate: doPaymentDate[index],
                      uploadDoC: uploadDoC[index],
                      doPaidBy: doPaidBy[index],
                    };

                    this.mainPageModal.doSection.push(obj);
                  });
                }
              }
            }
            if (otherNewContainerFLow == 1) {
              this.mainPageModal.doSection = [];
              if (doSectionArr.length > 0) {
                this.mainPageModal.doSection = doSectionArr;
              } else {
                this.mainPageModal.doSection.push({
                  doOrSecurity: "",
                  uploadDoC: "",
                  doParticulars: "",
                  doPaidBy: "",
                  doPaymentDate: "",
                });
              }
              this.mainPageModal.doReleaseDate = doReleaseDate;
              this.mainPageModal.doRemarks = doRemarks;
              this.mainPageModal.uploadDo = uploadDo;
              this.mainPageModal.otherNewContainerFLow = otherNewContainerFLow;
            }
            this.isLoading = false;
            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// ffSeaImportExecution.vue?e757f00c